import { DropDownBoxLabelSize } from '@apply/components/src/components/controls/DropDownBox';
import { usePropertyRentalBuildType } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DropDownBox, DropDownBoxComponentSpacing } from '@apply/components';
import { buildTypeString, buildTypes } from '@apply/ui';

export interface SiteBuiltOrManufacturedRentalProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const SiteBuiltOrManufacturedRental: React.FC<SiteBuiltOrManufacturedRentalProps> = ({
    propertyGuid,
    required = false,
    width,
    isReview = false,
}) => {
    const label = 'Is it a Site Built or Manufactured home? ';
    const [buildType, set_buildType] = usePropertyRentalBuildType(propertyGuid);

    const buildTypeList = [
        {
            display: buildTypeString(buildTypes.SiteBuilt),
            value: buildTypes.SiteBuilt,
        },
        {
            display: buildTypeString(buildTypes.Manufactured),
            value: buildTypes.Manufactured,
        },
    ];

    const findBuildTypeByValue = (value: number | undefined) => {
        return buildTypeList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findBuildTypeByValue(buildType)}
                />
            ) : (
                <DropDownBox
                    id={'siteBuiltOrManufacturedRentalDropDown'}
                    value={buildType}
                    onChange={(value) => set_buildType(parseInt(value))}
                    required={required}
                    dataSource={buildTypeList}
                    displayExpr={'display'}
                    valueExpr={'value'}
                    width={width}
                    label={label}
                    componentSpacing={DropDownBoxComponentSpacing.LargeSpacing}
                    labelSize={DropDownBoxLabelSize.Medium}
                />
            )}
        </>
    );
};
